import { $ as jquery } from 'jquery';
import { i18n } from '../core/i18n.js';
import { layer } from './layer.js';
import { pictureManage } from './pictureManage.js';
import { videoManage } from './videoManage.js';
import { musicManage } from './musicManage.js';
import { fileManage } from './fileManage.js';

var $ = jquery;

i18n.set({
  messages: {
    'zh-CN': {
      contentEditor: {
        preview: '预览',
        selectPicture: '选择图片',
        selectVideo: '选择视频',
        selectMusic: '选择音频',
        selectFile: '选择文件',
        aiEdit: 'AI编辑',
        previewTitle: '内容预览',
        previewCssPlaceholder: '预览CSS地址，多个地址可用换行、逗号或空格分隔',
        pictureUrlInserted: '图片URL插入成功',
        videoUrlInserted: '视频URL插入成功',
        musicUrlInserted: '音频URL插入成功',
        fileUrlInserted: '文件URL插入成功',
        aiEditTitle: 'AI编辑内容',
        promptLabel: '提示词',
        builtinPrompt: '内置提示词',
        promptPlaceholder: '请输入提示词，例如：\n- 优化这段HTML代码\n- 添加响应式设计\n- 修改颜色主题为蓝色\n- 添加动画效果',
        generate: '生成',
        clearContent: '清空内容',
        aiTip: '提示：AI会根据当前内容和提示词生成新的HTML+CSS+JS代码',
        promptRequired: '请输入提示词',
        aiUrlRequired: '未配置AI编辑接口',
        aiEditSuccess: 'AI编辑成功',
        generateFailed: '生成失败',
        requestFailed: '请求失败，请稍后重试',
        clearConfirm: '确定要清空当前内容吗？',
        contentCleared: '内容已清空'
      }
    },
    'en-US': {
      contentEditor: {
        preview: 'Preview',
        selectPicture: 'Select Image',
        selectVideo: 'Select Video',
        selectMusic: 'Select Audio',
        selectFile: 'Select File',
        aiEdit: 'AI Edit',
        previewTitle: 'Content Preview',
        previewCssPlaceholder: 'Preview CSS URLs, separated by line breaks, commas, or spaces',
        pictureUrlInserted: 'Image URL inserted',
        videoUrlInserted: 'Video URL inserted',
        musicUrlInserted: 'Audio URL inserted',
        fileUrlInserted: 'File URL inserted',
        aiEditTitle: 'AI Edit Content',
        promptLabel: 'Prompt',
        builtinPrompt: 'Built-in Prompt',
        promptPlaceholder: 'Enter a prompt, for example:\n- Optimize this HTML code\n- Add responsive design\n- Change color theme to blue\n- Add animation effects',
        builtinPromptTemplate: 'Please generate ad content code that can be directly used on a web page based on the following requirements:\n\n1. Output complete runnable HTML code, and you may include <style> and <script>.\n2. The code must be compatible with desktop and mobile devices, with responsive layout preferred.\n3. Do not rely on external frameworks such as Vue, React, jQuery, Bootstrap, or Tailwind.\n4. Use obvious placeholder content for images, videos, button links, and copy so I can replace them later.\n5. The visual style should focus on marketing conversion and be suitable for popups, banners, floating ads, or feed cards.\n6. If buttons are included, provide at least one primary CTA button and add data-ad-convert="1" to the conversion button.\n7. Use native CSS / JS for animation and interaction where possible, and avoid complex dependencies.\n8. Keep the code structure clear and class names semantic for easier secondary editing.\n9. If JavaScript is included, avoid polluting the global scope and prevent conflicts with other scripts on the page.\n10. Output final code only. Do not explain. Do not use Markdown code fences.\n\nThe current page content is shown below. You may optimize or rewrite it based on that content:',
        generate: 'Generate',
        clearContent: 'Clear Content',
        aiTip: 'Tip: AI will generate new HTML + CSS + JS based on current content and the prompt.',
        promptRequired: 'Please enter a prompt',
        aiUrlRequired: 'AI edit endpoint is not configured',
        aiEditSuccess: 'AI edit succeeded',
        generateFailed: 'Generation failed',
        requestFailed: 'Request failed, please try again later',
        clearConfirm: 'Are you sure you want to clear the current content?',
        contentCleared: 'Content cleared'
      }
    }
  }
});

var t = function (key, fallback, params) {
  return i18n.translate('contentEditor.' + key, params, { default: fallback });
};

var defaults = {
  elem: '',
  textarea: '',
  cssInput: '',
  name: 'content',
  value: '',
  previewArea: ['800px', '600px'],
  previewBodyStyle: 'body{margin:0;padding:20px;font-family:Arial,sans-serif;}',
  textareaStyle: 'height: 500px; font-family: Consolas, Monaco, monospace; font-size: 13px; line-height: 1.5;',
  toolbarStyle: 'margin-bottom: 5px;',
  cssInputStyle: 'margin-top: 8px;',
  baseUrl: '',
  aiUrl: '',
  aiPromptTemplate: '',
  lang: '',
  fileCategory: 0,
  texts: {},
  picture: {},
  video: {},
  music: {},
  file: {},
  buttons: {
    preview: true,
    picture: true,
    video: true,
    music: true,
    file: true,
    ai: true
  }
};

var extend = function () {
  var target = arguments[0] || {};
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] || {};
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (source[key] && typeof source[key] === 'object' && !Array.isArray(source[key]) && !(source[key] instanceof HTMLElement)) {
          target[key] = extend(target[key] && typeof target[key] === 'object' ? target[key] : {}, source[key]);
        } else {
          target[key] = source[key];
        }
      }
    }
  }
  return target;
};

var escapeHtml = function (value) {
  return String(value == null ? '' : value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
};

var normalizeId = function (id) {
  return String(id || '').replace(/^#/, '');
};

var normalizeUrl = function (baseUrl, path) {
  if (!path) {
    return '';
  }
  if (/^(https?:)?\/\//i.test(path) || /^data:/i.test(path)) {
    return path;
  }
  return String(baseUrl || '') + path;
};

function ContentEditor() {}

ContentEditor.prototype.options = {};

ContentEditor.prototype.init = function (options) {
  this.options = extend({}, defaults, options || {});
  this.ids = {};
  this.render();
  return this;
};

ContentEditor.prototype.text = function (key, fallback, params) {
  var texts = this.options.texts || {};
  return texts[key] == null ? t(key, fallback, params) : texts[key];
};

ContentEditor.prototype.createId = function (suffix) {
  var base = normalizeId(this.options.elem) || 'contentEditor';
  return base + '_' + suffix;
};

ContentEditor.prototype.getTextarea = function () {
  return document.getElementById(normalizeId(this.options.textarea || this.ids.textarea));
};

ContentEditor.prototype.insertAtCursor = function (text) {
  var textarea = this.getTextarea();
  if (!textarea) {
    return;
  }
  var start = textarea.selectionStart || 0;
  var end = textarea.selectionEnd || 0;
  var value = textarea.value || '';
  textarea.value = value.substring(0, start) + text + value.substring(end);
  textarea.selectionStart = textarea.selectionEnd = start + text.length;
  textarea.focus();
};

ContentEditor.prototype.render = function () {
  var options = this.options;
  var elemId = normalizeId(options.elem);
  var $elem = $('#' + elemId);
  if (!$elem.length) {
    return this;
  }

  this.ids = {
    toolbar: this.createId('toolbar'),
    preview: this.createId('preview'),
    picture: this.createId('picture'),
    video: this.createId('video'),
    music: this.createId('music'),
    file: this.createId('file'),
    ai: this.createId('ai'),
    textarea: normalizeId(options.textarea) || this.createId('textarea'),
    cssInput: normalizeId(options.cssInput) || this.createId('previewCssUrls')
  };

  var buttons = options.buttons || {};
  var html = '';
  html += '<div class="editor-toolbar" id="' + this.ids.toolbar + '" style="' + escapeHtml(options.toolbarStyle) + '">';
  if (buttons.preview) {
    html += '<button type="button" class="layui-btn layui-btn-sm layui-btn-primary" id="' + this.ids.preview + '"><i class="layui-icon">&#xe615;</i> ' + escapeHtml(this.text('preview', '预览')) + '</button>';
  }
  if (buttons.picture) {
    html += '<button type="button" class="layui-btn layui-btn-sm layui-btn-primary" id="' + this.ids.picture + '"><i class="layui-icon">&#xe67c;</i> ' + escapeHtml(this.text('selectPicture', '选择图片')) + '</button>';
  }
  if (buttons.video) {
    html += '<button type="button" class="layui-btn layui-btn-sm layui-btn-primary" id="' + this.ids.video + '"><i class="layui-icon">&#xe6ed;</i> ' + escapeHtml(this.text('selectVideo', '选择视频')) + '</button>';
  }
  if (buttons.music) {
    html += '<button type="button" class="layui-btn layui-btn-sm layui-btn-primary" id="' + this.ids.music + '"><i class="layui-icon">&#xe6fc;</i> ' + escapeHtml(this.text('selectMusic', '选择音频')) + '</button>';
  }
  if (buttons.file) {
    html += '<button type="button" class="layui-btn layui-btn-sm layui-btn-primary" id="' + this.ids.file + '"><i class="layui-icon">&#xe655;</i> ' + escapeHtml(this.text('selectFile', '选择文件')) + '</button>';
  }
  if (buttons.ai) {
    html += '<button type="button" class="layui-btn layui-btn-sm layui-btn-primary" id="' + this.ids.ai + '"><i class="layui-icon layui-icon-fire"></i> ' + escapeHtml(this.text('aiEdit', 'AI编辑')) + '</button>';
  }
  html += '</div>';
  html += '<textarea type="text" id="' + this.ids.textarea + '" name="' + escapeHtml(options.name) + '" class="layui-textarea" style="' + escapeHtml(options.textareaStyle) + '">' + escapeHtml(options.value) + '</textarea>';
  html += '<input type="text" id="' + this.ids.cssInput + '" class="layui-input" autocomplete="off" placeholder="' + escapeHtml(this.text('previewCssPlaceholder', '预览CSS地址，多个地址可用换行、逗号或空格分隔')) + '" style="' + escapeHtml(options.cssInputStyle) + '">';

  $elem.html(html);
  this.bind();
  return this;
};

ContentEditor.prototype.bind = function () {
  var that = this;
  var options = this.options;
  var buttons = options.buttons || {};

  if (buttons.preview) {
    $('#' + this.ids.preview).off('click').on('click', function () {
      that.preview();
    });
  }

  if (buttons.picture) {
    this.initPictureManage();
  }
  if (buttons.video) {
    this.initVideoManage();
  }
  if (buttons.music) {
    this.initMusicManage();
  }
  if (buttons.file) {
    this.initFileManage();
  }
  if (buttons.ai) {
    $('#' + this.ids.ai).off('click').on('click', function () {
      that.openAiEditor();
    });
  }
};

ContentEditor.prototype.preview = function () {
  var content = $('#' + this.ids.textarea).val();
  var cssLinks = '';
  var cssUrls = ($('#' + this.ids.cssInput).val() || '').split(/[\s,，]+/);
  for (var i = 0; i < cssUrls.length; i++) {
    var cssUrl = $.trim(cssUrls[i]);
    if (cssUrl !== '') {
      cssLinks += '<link rel="stylesheet" href="' + escapeHtml(cssUrl) + '">';
    }
  }
  var iframeContent = '<!DOCTYPE html><html><head><meta charset="utf-8">' + cssLinks + '<style>' + this.options.previewBodyStyle + '</style></head><body>' + content + '</body></html>';

  layer.open({
    type: 1,
    title: this.text('previewTitle', '内容预览'),
    area: this.options.previewArea,
    shadeClose: true,
    scrollbar: false,
    content: '<iframe id="previewContentIframe" style="width:100%;height:100%;border:none;display:block;overflow:auto;"></iframe>',
    success: function () {
      var iframe = document.getElementById('previewContentIframe');
      if (iframe && iframe.contentWindow) {
        iframe.contentWindow.document.open();
        iframe.contentWindow.document.write(iframeContent);
        iframe.contentWindow.document.close();
      }
    }
  });
};

ContentEditor.prototype.initPictureManage = function () {
  var that = this;
  var manage = new pictureManage();
  manage.init(extend({}, this.options.picture, {
    elem: this.ids.picture,
    multiple: false,
    pictureCategory: parseInt(this.options.fileCategory, 10) || 0,
    callback: function (a, b, c) {
      if (a == 'select' && c) {
        that.insertAtCursor(normalizeUrl(that.options.baseUrl, c));
        layer.msg(that.text('pictureUrlInserted', '图片URL插入成功'), { icon: 1 });
      }
    }
  }));
  $('#' + this.ids.picture).off('click').on('click', function () {
    manage.render();
  });
};

ContentEditor.prototype.initVideoManage = function () {
  var that = this;
  var manage = new videoManage();
  manage.init(extend({}, this.options.video, {
    elem: this.ids.video,
    multiple: false,
    videoCategory: parseInt(this.options.fileCategory, 10) || 0,
    callback: function (a, b, c) {
      if (a == 'select' && c) {
        that.insertAtCursor(normalizeUrl(that.options.baseUrl, c));
        layer.msg(that.text('videoUrlInserted', '视频URL插入成功'), { icon: 1 });
      }
    }
  }));
  $('#' + this.ids.video).off('click').on('click', function () {
    manage.render();
  });
};

ContentEditor.prototype.initMusicManage = function () {
  var that = this;
  var manage = new musicManage();
  manage.init(extend({}, this.options.music, {
    elem: this.ids.music,
    multiple: false,
    musicCategory: parseInt(this.options.fileCategory, 10) || 0,
    callback: function (a, b, c) {
      if (a == 'select' && c) {
        that.insertAtCursor(normalizeUrl(that.options.baseUrl, c));
        layer.msg(that.text('musicUrlInserted', '音频URL插入成功'), { icon: 1 });
      }
    }
  }));
  $('#' + this.ids.music).off('click').on('click', function () {
    manage.render();
  });
};

ContentEditor.prototype.initFileManage = function () {
  var that = this;
  var manage = new fileManage();
  manage.init(extend({}, this.options.file, {
    elem: this.ids.file,
    multiple: false,
    fileCategory: parseInt(this.options.fileCategory, 10) || 0,
    callback: function (a, b, c) {
      if (a == 'select' && c) {
        that.insertAtCursor(normalizeUrl(that.options.baseUrl, c.path || c.src || c.url || ''));
        layer.msg(that.text('fileUrlInserted', '文件URL插入成功'), { icon: 1 });
      }
    }
  }));
  $('#' + this.ids.file).off('click').on('click', function () {
    manage.render();
  });
};

ContentEditor.prototype.openAiEditor = function () {
  var that = this;
  var currentContent = $('#' + this.ids.textarea).val();
  var builtinPrompt = $.trim(this.options.aiPromptTemplate || '');
  var builtinPromptHtml = '';
  if (builtinPrompt) {
    var builtinPromptContent = builtinPrompt;
    if (currentContent) {
      builtinPromptContent += '\n\n' + currentContent;
    }
    builtinPromptHtml = [
      '  <div class="layui-form-item" style="margin-bottom: 12px;">',
      '    <label class="layui-form-label" style="width: 100px;">' + escapeHtml(this.text('builtinPrompt', '内置提示词')) + '</label>',
      '    <div class="layui-input-block" style="margin-left: 130px;">',
      '      <textarea readonly class="layui-textarea" style="height: 120px; overflow-y: auto;">' + escapeHtml(builtinPromptContent) + '</textarea>',
      '    </div>',
      '  </div>'
    ].join('');
  }

  layer.open({
    type: 1,
    title: this.text('aiEditTitle', 'AI编辑内容'),
    area: ['720px', '460px'],
    shadeClose: true,
    content: [
      '<div style="padding: 20px; box-sizing: border-box; height: 100%; overflow: hidden;">',
      builtinPromptHtml,
      '  <div class="layui-form-item" style="margin-bottom: 12px;">',
      '    <label class="layui-form-label" style="width: 100px;">' + escapeHtml(this.text('promptLabel', '提示词')) + '</label>',
      '    <div class="layui-input-block" style="margin-left: 130px;">',
      '      <textarea id="aiPromptInput" class="layui-textarea" placeholder="' + escapeHtml(this.text('promptPlaceholder', '请输入提示词，例如：\n- 优化这段HTML代码\n- 添加响应式设计\n- 修改颜色主题为蓝色\n- 添加动画效果')) + '" style="height: 88px; overflow-y: auto; resize: none; box-sizing: border-box;"></textarea>',
      '    </div>',
      '  </div>',
      '  <div class="layui-form-item" style="margin-bottom: 12px;">',
      '    <div class="layui-input-block" style="margin-left: 130px;">',
      '      <button type="button" class="layui-btn layui-btn-primary" id="aiGenerateBtn"><i class="layui-icon layui-icon-fire"></i> ' + escapeHtml(this.text('generate', '生成')) + '</button>',
      '      <button type="button" class="layui-btn layui-btn-primary" id="aiClearBtn"><i class="layui-icon">&#xe640;</i> ' + escapeHtml(this.text('clearContent', '清空内容')) + '</button>',
      '    </div>',
      '  </div>',
      '  <div class="layui-form-mid layui-word-aux" style="margin-left: 130px; color: #999;">' + escapeHtml(this.text('aiTip', '提示：AI会根据当前内容和提示词生成新的HTML+CSS+JS代码')) + '</div>',
      '</div>'
    ].join(''),
    success: function (layero, index) {
      $('#aiGenerateBtn').off('click').on('click', function () {
        var prompt = $.trim($('#aiPromptInput').val());
        if (!prompt) {
          layer.msg(that.text('promptRequired', '请输入提示词'), { icon: 2 });
          return;
        }
        if (!that.options.aiUrl) {
          layer.msg(that.text('aiUrlRequired', '未配置AI编辑接口'), { icon: 2 });
          return;
        }

        var load = layer.load(2, { shade: [0.3, '#000'] });
        $.ajax({
          type: 'POST',
          url: that.options.aiUrl,
          data: {
            content: currentContent,
            prompt: prompt,
            lang: that.options.lang || ''
          },
          dataType: 'json',
          success: function (result) {
            layer.close(load);
            if (result.code == '0') {
              $('#' + that.ids.textarea).val(result.data.content);
              layer.close(index);
              layer.msg(that.text('aiEditSuccess', 'AI编辑成功'), { icon: 1, time: 2000 });
            } else {
              layer.msg(result.msg || that.text('generateFailed', '生成失败'), { icon: 2, time: 2000 });
            }
          },
          error: function () {
            layer.close(load);
            layer.msg(that.text('requestFailed', '请求失败，请稍后重试'), { icon: 2, time: 2000 });
          }
        });
      });

      $('#aiClearBtn').off('click').on('click', function () {
        layer.confirm(that.text('clearConfirm', '确定要清空当前内容吗？'), function (i) {
          $('#' + that.ids.textarea).val('');
          layer.close(i);
          layer.close(index);
          layer.msg(that.text('contentCleared', '内容已清空'), { icon: 1 });
        });
      });
    }
  });
};

export { ContentEditor as contentEditor };
